import { STRATEGY_MESSAGES } from '../strategyMessages';
export class galateaMessageService {
    static newMessage(json) {
        if (STRATEGY_MESSAGES[json.action]) {
            STRATEGY_MESSAGES[json.action](json);
        }
    }
}


// WEBPACK FOOTER //
// ./src/Services/galateaMessageService.js